import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { DASHBOARD_V1_URLS } from "@/apps/dashboard/services/apiClient/apiUrl";

export const navigationGuardForRedirectedDashboardUser = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): void => {
  const sessionToken = sessionStorage.getItem("PJ_DashboardJwt") ?? false;
  if (!sessionToken) {
    let jwtSetterAttempts: number = parseInt(
      sessionStorage.getItem("jwtSetterAttempts") ?? "0"
    );
    const jwtSetterHandler = (event) => {
      if (event.data.token) {
        sessionStorage.removeItem("jwtSetterAttempts");

        sessionStorage.setItem("PJ_DashboardJwt", event.data.token);
        window.removeEventListener("message", jwtSetterHandler); // Clean up the event listener
        // This is needed due to a bug in our app, session storage is not loaded
        // correctly after being set
        // Adding a delay to ensure session storage is properly set before reload
        setTimeout(() => {
          window.location.reload();
        }, 100);
        next(false);
      } else {
        jwtSetterAttempts++;
        sessionStorage.setItem(
          "jwtSetterAttempts",
          jwtSetterAttempts.toString()
        );

        // Redirect to Dashboard V1 if attempts exceed 3
        if (jwtSetterAttempts > 3) {
          setTimeout(() => {
            window.location.href = DASHBOARD_V1_URLS.HOME;
          }, 500); // Wait 500ms before redirecting to Dashboard V1
        }
      }
    };

    window.addEventListener("message", jwtSetterHandler);
  } else {
    next();
  }
};
